const getPublishingStatus = (rootState) => rootState.ui.publishing.status;

export default getPublishingStatus;
